// eslint-disable-next-line @typescript-eslint/ban-ts-comment
// @ts-nocheck
import { formatDate } from 'shared/utils/time/format-date';

const dateKeys = [
  'loadingDate',
  'unloadingDate',
  'orderDate',
  'createdAt',
  'date',
  'arrivalDate',
  'departureDate',
  'comparisonDate',
  'endDate',
];

export const setFiltersToQs = <T extends object>(qs: URLSearchParams, filters: T) => {
  Object.keys(filters).forEach((key) => {
    if (Array.isArray(filters[key]) && dateKeys.includes(key)) {
      const from = filters[key][0] && formatDate(filters[key][0]);
      const to = filters[key][1] && formatDate(filters[key][1]);

      if (from) qs.set(`filter[${key}From]`, from);
      if (to) qs.set(`filter[${key}To]`, to);
    } else if (Array.isArray(filters[key])) {
      (filters[key] as Array<string>).forEach((value, index) => {
        qs.set(`filter[${key}][${index}]`, value);
      });
    } else if (typeof filters[key] === 'object') {
      qs.set(`filter[${key}]`, filters[key]?.value as string);
    } else {
      qs.set(`filter[${key}]`, filters[key] as string);
    }
  });
};
